<template lang="pug">
section
  header.d-flex.row.flex-row.align-items-end.mb-3
    .col
      router-link.button-previous.mr-2(to="/administracion/id/")
          i.fas.fa-chevron-left
      h1.m-0.d-inline-block.align-middle
        i Administración de Kpi Adherencia
    .col-auto
      router-link.btn.btn-secondary.py-2.px-4(to="kpi-adherencia-create")
        i.icon.icon-plus.icon--1x.mr-2
        strong Nuevo Kpi Adherencia
  section
    .d-flex.flex-row.align-items-stretch.mt-4.ad_border1-secondary.rounded-xl.py-1.w-50.ml-auto
      .col
        input.h-100.w-100.border-0(v-model='search', placeholder='Buscar por nombre')
      .col-auto
        b-button.py-1(:disabled='!search', @click="onFiltered", @keyup.enter.native="onFiltered()", title='Buscar')
          i.icon.icon--1x.icon-search
      .col-auto
        b-button.py-1(:disabled='!search', @click="cleanFilter", title='Limpiar filtro')
          i.icon.icon--1x.icon-cross    
    .row.mt-4
      .col-auto.ml-auto
        b-button.py-1.px-2(@click="cleanSort", title='Limpiar ordenamiento')
          i.icon.icon--1x.icon-sort-amount-asc
          strong Limpiar ordenamiento

    .d-flex.row.flex-row.align-items-start.mt-4
      .col-12
        .card.p-0.ad_bg-gray.rounded-xl
          .card-body
            b-table.table-simple.no-border(
              show-empty
              stacked="md"
              :items='kpis',
              :fields="fields",
              :current-page="0",
              :per-page="selectedPerPage",
              :no-local-sorting="true",
              @sort-changed="sortingChanged")
              template(slot='rol', slot-scope='row')
                .div(v-if="row.item.role")
                  | {{row.item.role.name}}
                  
              template(slot='edit', slot-scope='row')
                router-link(:to="{path:'/administracion/'+row.item._id+'/kpi-adherencia-edit'}" title="Editar usuario" append)
                  i.icon.icon-pencil3
              template(slot='delete', slot-scope='row')
                router-link(to="#" title="Eliminar usuario" append)
                  i.icon.icon-bin(@click="deleteKpiAdherencia(row.item, row.index, $event.target)")
              
            .row.mt-5
              .col-auto
                p Total de Kpi Adherencia:
                  |  {{ totalRows }}
              .col-auto.ml-auto
                .ad_select.px-3
                  select(v-model='perPage', @change="changePerPage()")
                    option(:value="null" disabled selected) Items
                    option(:value="numero", v-for="numero in itemsPerPAge") {{numero}}
              .col-auto.ml-auto                
                sliding-pagination(
                  :current="currentPage"
                  :total="totalPages"
                  @page-change="pageChangeHandler")
                
                  
  b-modal(:id='infoModal.id' :title='infoModal.title' @ok="handleOk")
    p {{ infoModal.content }}
  
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AdministracionKpiAdherencia',
  components: {},
  data () {
    return {
      user: null,
      kpis: null,
      filter: null,
      fields: [
        { key: 'rol', label: 'Rol', sortable: true},
        { key: 'name', label: 'Nombre', sortable: true},
        { key: 'goal', label: 'Meta', sortable: true},
        { key: "edit", label: "Editar" },
        { key: "delete", label: "Eliminar" }
      ],
      infoModal: {
        id: 'info-modal',
        title: 'Eliminar Kpi adherencia',
        content: ''
      },
      search: '',
      sort: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      itemsPerPAge: [10,20,30],
      selectedPerPage: 10
    }
  },
  methods: {
    ...mapActions('kpi', [
      'kpiList', 'updateKpi', 'deleteKpi', 'updateSortAd', 'updateCurrentPage'
    ]),
    onlyUsersActives(items) {
      return items.filter(u => u.isDeleted === false)
    },
    listKpi() {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')      
      vm.kpiList({
        pagination: {page: vm.currentPage, perPage: vm.perPage}, 
        sort: vm.sort, 
        search: vm.search})
      .then((kpis) => {
        let response = vm.$store.getters['kpi/getKpis']
        vm.kpis = response.docs
        // vm.currentPage = response.page
        vm.selectedPerPage = vm.perPage
        vm.totalRows = response.total
        vm.totalPages =  response.totalPages
        loading.hide()
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    onFiltered(filteredItems) {
      const vm = this    
      vm.currentPage = 1
      vm.listKpi()      
    },
    sortingChanged(ctx) {
      const vm = this
      vm.currentPage = 1
      let newSort = true
      for (let index in vm.sort) {
        if (vm.sort[index].sortBy == ctx.sortBy) {
          vm.sort[index].sortDesc = ctx.sortDesc
          newSort = false
        }
      }
      for (let indexf in vm.fields) {
        if (vm.fields[indexf].key == ctx.sortBy) {
          // vm.fields[indexf].
        } 
      }
      if (newSort) {
        vm.sort.push({sortBy: ctx.sortBy, sortDesc: ctx.sortDesc})
        vm.updateSortAd(vm.sort)
      }      
      vm.listKpi()      
    },
    deleteKpiAdherencia(item, index, button) {
      const vm = this
      vm.$root.$emit('bv::show::modal', vm.infoModal.id, button)
      const modal = vm.$el.querySelector('.modal')
      modal.style.left = '25%'
      modal.style.right = '25%'
      modal.style.top = '25%'
      modal.style.height = '240px'
      vm.infoModal.content = `¿Está seguro de eliminar el Kpi Adherencia "${item.name}"?`
      vm.infoModal.kpiId = item._id
    },
    handleOk() {
      const vm = this
      const data = {id: vm.infoModal.kpiId, isDeleted: true}
      
      vm.deleteKpi(data).then((kpi) => {
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'Kpi Adherencia eliminado',
          closeable: true,
          duration: 5000
        })
        vm.listKpi()
      }).catch(e => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: e.payload.message.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    pageChangeHandler(selectedPage) {
      const vm = this
      vm.currentPage = selectedPage
      vm.updateCurrentPage(selectedPage).then(() => {       
        vm.listKpi()
      })
    },
    changePerPage(){
      const vm = this
      vm.currentPage = 1
      vm.updateCurrentPage(1).then(() => {
        vm.listKpi()
      })
    },
    cleanFilter() {
      const vm = this
      vm.updateCurrentPage(1).then(() => {
        vm.currentPage = 1
        vm.search = null
        vm.listKpi()
      })      
    },
    cleanSort() {
      const vm = this
      vm.sort = []
      vm.currentPage = 1
      vm.updateCurrentPage(1).then(() => {
        vm.updateSortAd([]).then(() => {
          vm.listKpi()
        })
      })  
    }
  },
  watch: {
    search: function() {
      const vm = this
      if (vm.search == '') {
        vm.listKpi()
      }
    }
  },
  mounted() {
    const vm = this
    vm.sort = vm.$store.getters['kpi/getSortAd']
    vm.currentPage = vm.$store.getters['kpi/getCurrentPage']
    if (vm.$route.query.restart) {
      vm.currentPage = 1
    }    
    vm.listKpi()
  }
};
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/administracion-kpi.vue